/**
 * Whether this browser can draw the scene at all (D210).
 *
 * @remarks
 * WebGL is absent more often than a desk with a GPU suggests: some
 * corporate browsers switch it off, some old phones never had it, and a
 * few privacy settings refuse the context. The shell asks this ONCE before
 * choosing the scene, and lays the hologram out instead when the answer is
 * no — so a player is never shown a chooser entry that draws nothing.
 *
 * The probe creates one canvas and asks it for a context; a browser that
 * throws on the ask is a browser without one.
 *
 * @packageDocumentation
 */

/** Whether a canvas here can give a WebGL context. */
export const isWebGlAvailable = (createCanvas: () => HTMLCanvasElement = () => document.createElement('canvas')): boolean => {
	try {
		const canvas = createCanvas();

		return canvas.getContext('webgl2') !== null || canvas.getContext('webgl') !== null;
	} catch {
		return false;
	}
};
